import { useQuery } from '@tanstack/react-query'
import type { UseBaseQueryOptions } from '@tanstack/react-query'
import AdminAssetsService from '../../services'
import { AdminAssetsQueryKeys } from '@/modules/admin-assets/keys'
import type { AdminAssetsResponse } from '../../services'

export default function useQueryGetAdminAssets(
	props?: UseBaseQueryOptions<AdminAssetsResponse>,
) {
	return useQuery({
		queryKey: [AdminAssetsQueryKeys.ADMIN_ASSETS],
		queryFn: () => AdminAssetsService.getAdminAssets(),
		...props,
	})
}
